import * as React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { IUserType, useAuth } from "./App";
import { UserApi } from "./api/UserApi";
import './assets/styles/common.scss';
import { Navbar } from './components/Navbar/Navbar';
import { SessionExpiredModal } from "./components/SessionExpiredModal/SessionExpiredModal";
import { UnauthorizedModal } from './components/UnauthorizedModal/UnauthorizedModal';
import { Clinic } from "./components/views/Clinic/Clinic";
import { Home } from './components/views/Home/Home';
import { Municipality } from "./components/views/Municipality/Municipality";
import { Organisation } from "./components/views/Organisation/Organisation";
import { Residence } from "./components/views/Residence/Residence";
import { SelectClinic } from "./components/views/SelectClinic/SelectClinic";
import { InitUserInfo, UserContext } from "./contexts/UserContext";
import { IUserInfo } from "./models/IUserInfo";
import { MENUETTPORTAL, MENUETTPORTALKOMMUN } from "./utils/ApplicationConstants";
import { MEN_PORTAL_WEB_BASE_PATH } from "./utils/Config";
import { CLINIC, MUNICIPALITY, ORGANISATION, RESIDENCE, SELECT_CLINIC } from "./utils/RouteConstants";

export const AuthenticatedApp: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const userApi = new UserApi(auth);
    const [userInfo, setUserInfo] = React.useState<IUserInfo>();
    const [isAuthorized, setIsAuthorized] = React.useState<boolean>(false);
    const [hasUserRoleGroupSet, setHasUserRoleGroupSet] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (auth.isAuthenticated) {
            if (auth.userType === IUserType.CareProvider) {
                getMenuettPortalUser();
            } else if (auth.userType === IUserType.Municipality) {
                getMenuettPortalKommunUser();
            }
        } else {
            document.getElementById("open-session-expired-modal")?.click();
        }
    }, [, auth.userRolesGroup, auth.isAuthenticated]);

    const getMenuettPortalUser = () => {
        userApi.getUser(MENUETTPORTAL, (userInfo: IUserInfo) => {
            setUserInfo(userInfo);
            auth.setUserRolesGroup(userInfo.rolesGroupId, IUserType.CareProvider);
            setHasUserRoleGroupSet(true);
            setIsAuthorized(true);
        }, () => {
            if (hasUserRoleGroupSet) {
                setIsAuthorized(false);
                document.getElementById("open-unauthorized-modal")?.click();
            } else {
                getMenuettPortalKommunUser();
            }
        });
    }

    const getMenuettPortalKommunUser = () => {
        userApi.getUser(MENUETTPORTALKOMMUN, (userMunInfo: IUserInfo) => {
            setUserInfo(userMunInfo);
            auth.setUserRolesGroup(userMunInfo.rolesGroupId, IUserType.Municipality);
            setHasUserRoleGroupSet(true);
            setIsAuthorized(true)
        }, () => {
            setIsAuthorized(false);
            document.getElementById("open-unauthorized-modal")?.click();
        });
    }

    return (
        <UserContext.Provider value={userInfo ? userInfo : InitUserInfo}>
            <Router basename={MEN_PORTAL_WEB_BASE_PATH}>
                <Navbar />
                {auth.isAuthenticated && isAuthorized ?
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route exact path={`/${ORGANISATION}/:id`}>
                            <Organisation />
                        </Route>
                        <Route exact path={`/${CLINIC}/:id`}>
                            <Clinic />
                        </Route>
                        <Route exact path={`/${SELECT_CLINIC}`}>
                            <SelectClinic />
                        </Route>
                        <Route exact path={`/${MUNICIPALITY}`}>
                            <Municipality />
                        </Route>
                        <Route exact path={`/${RESIDENCE}/:id`}>
                            <Residence />
                        </Route>
                    </Switch>
                    :
                    <>
                        <input type="hidden" data-toggle="modal" id="open-session-expired-modal" data-target="#session-expired-modal" />
                        <SessionExpiredModal />
                        <input type="hidden" data-toggle="modal" id="open-unauthorized-modal" data-target="#unauthorized-modal" />
                        <UnauthorizedModal />
                    </>
                }

            </Router>
        </UserContext.Provider>
    );
}